<div class="modal-header">
  <div class="modal-header-content">
    <img class="icon rounded-circle" [src]="collaborator?.thumbnail | authImage | async">
    <div class="d-flex flex-column">
      <p class="name modal-title">{{collaborator?.name}} {{collaborator?.surname}}</p>
      <p class="email modal-subtitle">{{collaborator?.email}}</p>
    </div>
  </div>
  <i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
</div>
<div class="modal-body">
  <p class="subtitle">Has access to these workspaces and projects</p>
  <div class="scroll">
    <div class="border row-dimension" *ngFor="let workspace of workspaces">
      <div class="ws-content">
        <img class="ws-icon" src="assets/images/type_workspace.svg" alt="" />
        <div class="d-block">
          <div class="ws-name">{{workspace?.name}}</div>
          <div class="ws-projects">{{workspace?.permission === 'Write' ? 'All projects' : projectsName}}</div>
        </div>
      </div>
      <a class="remove" [ngClass]="{'text-secondary': workspace.isRemoved, 'text-accent': !workspace.isRemoved}" 
        (click)="workspace.isRemoved = !workspace.isRemoved">
        {{workspace.isRemoved ? 'Removed' : 'Remove'}}
      </a>
    </div>
  </div>
</div>
<div class="modal-footer pt-5">
  <button type="button" class="btn btn-outline-dark" (click)="onDelete()">Cancel</button>
  <button class="btn btn-default ml-3" type='submit' (click)="confirmData()">Confirm</button>
</div>
